import { useMutation } from "react-query"
import employeesService from "api/employeesService"

import { IAddEmployeeBodyParams } from "types/employee"

const useAddEmployeeMutation = () => {
  return useMutation(async (data: IAddEmployeeBodyParams) => {
    try {
      const res = await employeesService.addEmployee(data)

      return true
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useAddEmployeeMutation
